


















import inputMixin from 'library/mixins/input-mixin'
export default

	mixins: [ inputMixin ]

	props:
		name: String
		label: String
		checked:
			type: Boolean
			default: false
		type:
			type: String
			default: ""
		value: Boolean
		# Loading state is used in flyout menu
		loading: Boolean


	computed:
		classes: -> 'inverted' if @inverted

